/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type EnableWebhooksSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type EnableWebhooksRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type EnableWebhooksSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const EnableWebhooksSecurity$outboundSchema: z.ZodMiniType<
  EnableWebhooksSecurity$Outbound,
  EnableWebhooksSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function enableWebhooksSecurityToJSON(
  enableWebhooksSecurity: EnableWebhooksSecurity,
): string {
  return JSON.stringify(
    EnableWebhooksSecurity$outboundSchema.parse(enableWebhooksSecurity),
  );
}

/** @internal */
export type EnableWebhooksRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const EnableWebhooksRequest$outboundSchema: z.ZodMiniType<
  EnableWebhooksRequest$Outbound,
  EnableWebhooksRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function enableWebhooksRequestToJSON(
  enableWebhooksRequest: EnableWebhooksRequest,
): string {
  return JSON.stringify(
    EnableWebhooksRequest$outboundSchema.parse(enableWebhooksRequest),
  );
}
